import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants/api';
import { useParams } from 'react-router-dom';
import { removeFields } from '../../utils/ktcUtils';

function InvoicePage() {
  const [company, setCompany] = useState([]);
  const [data, setData] = useState([]);

  const { route, id } = useParams();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );

        console.log(response.data.company);
        setCompany(response.data.company[0]);
        const company = response.data.company[0];

        if (company?.name) {
          document.title = company.name;
        }

        // Set Favicon
        if (company?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) {
            favicon.href = company.logo; // Update favicon dynamically
          }
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    const fetchInvoice = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/sys/invoice/${route}/${id}`
        );

        console.log(response.data);
        setData(response.data);
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    fetchCompany();

    fetchInvoice();
    //window.print();
  }, [data]);
  const renderRowInvoice = (key, value) => {
    // Handle date formatting or null value
    if (value === null) {
      value = 'Not provided';
    }

    // Render key-value pair in grid
    return (
      <div
        className="col-6"
        style={{ borderBottom: '1px dashed #000', paddingBottom: '1px' }}
      >
        <p>
          {' '}
          <strong>{key.charAt(0).toUpperCase() + key.slice(1)} :</strong>{' '}
          {value}
        </p>
      </div>
    );
  };

  // Filter out the 'image' field from the data to prevent it from being included in the grid
  // const filteredData = { ...data };
  // delete filteredData.image; // Remove the image key from the data
  // delete filteredData.title; // Remove the image key from the data
  const fieldsToRemove = [
    'image',
    'title',
    'copy',
    'note',
    'signature',
    'signature2',
  ];

  const filteredData = removeFields(data, fieldsToRemove);
  // console.log('filteredData:', filteredData);
  // console.log('data:', data);

  // Create an array of rows with key-value pairs from the filtered data
  const invoiceRows = Object.entries(filteredData).map(
    ([key, value], index) => {
      // Return rows in pairs (2 items per row)
      if (index % 2 === 0) {
        return (
          <div className="row mt-2" key={key}>
            {renderRowInvoice(key, value)}
            {Object.entries(filteredData)[index + 1] &&
              renderRowInvoice(
                Object.entries(filteredData)[index + 1][0],
                Object.entries(filteredData)[index + 1][1]
              )}
          </div>
        );
      }
      return null;
    }
  );

  // Create an array of rows with key-value pairs from the filtered data
  const letterRows = Object.entries(filteredData).map(([key, value], index) => {
    return (
      <div className="row mt-4" key={key}>
        <div className="col-8" style={{ borderBottom: '1px dashed #000' }}>
          <strong>{key}:</strong> {value}
        </div>
      </div>
    );
  });

  return (
    <div className="">
      <div className="">
        {/* Display Image Above Invoice */}
        {company.banner && (
          <div className="row mb-4">
            <div className="col-12">
              <center>
                <img
                  src={`${API_URL}/${company.banner}`}
                  alt="Company"
                  className="img-fluid"
                  style={{ maxWidth: '100%' }}
                />
              </center>
            </div>
          </div>
        )}
        <div className="">
          {/* Display Image Above Invoice */}

          {data.title && (
            <div className="row mb-4">
              <div className="col-12">
                <center>
                  <h1>{data.title}</h1>
                </center>
              </div>
            </div>
          )}

          {/* Display Image Above Invoice */}
          {data.image && (
            <div className="row mb-4">
              <div className="col-8">
                {Object.entries(filteredData).map(([key, value], index) => {
                  return (
                    <div className="row mt-2" key={key}>
                      <div
                        className="col-12"
                        style={{ borderBottom: '1px dashed #000' }}
                      >
                        <strong>{key}:</strong> {value}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="col-4">
                <br />

                <center>
                  <img
                    src={`${API_URL}/${data.image}`}
                    alt="Company"
                    className="img-fluid"
                    style={{ maxWidth: '100%' }}
                  />
                </center>
              </div>
            </div>
          )}

          {/* Rest of the Invoice Data */}
          {/* {letterRows} */}

          {!data.image && <div>{invoiceRows}</div>}

          {data.note && (
            <div className="row mb-4">
              <div className="col-12">
                <p>{data.note}</p>
              </div>
            </div>
          )}

          <div className="row mb-4">
            {data.signature && (
              <div className={`col-${data.signature2 ? '6' : '12'}`}>
                <center>
                  <br />
                  <p>{data.signature}</p>
                  _____________________________
                </center>
              </div>
            )}
            {data.signature2 && (
              <div className={`col-${data.signature ? '6' : '12'}`}>
                <center>
                  <br />
                  <p>{data.signature2}</p>
                  _____________________________
                </center>
              </div>
            )}
          </div>
        </div>
      </div>
      {data.copy && (
        <>
          <br />
          <hr />
          <br />

          <div className="">
            {/* Display Image Above Invoice */}
            {company.banner && (
              <div className="row mb-4">
                <div className="col-12">
                  <center>
                    <img
                      src={`${API_URL}/${company.banner}`}
                      alt="Company"
                      className="img-fluid"
                      style={{ maxWidth: '100%' }}
                    />
                  </center>
                </div>
              </div>
            )}
            <div className="">
              {/* Display Image Above Invoice */}

              {data.title && (
                <div className="row mb-4">
                  <div className="col-12">
                    <center>
                      <h1>{data.title}</h1>
                    </center>
                  </div>
                </div>
              )}

              {/* Display Image Above Invoice */}
              {data.image && (
                <div className="row mb-4">
                  <div className="col-8">
                    {Object.entries(filteredData).map(([key, value], index) => {
                      return (
                        <div className="row mt-2" key={key}>
                          <div
                            className="col-12"
                            style={{ borderBottom: '1px dashed #000' }}
                          >
                            <strong>{key}:</strong> {value}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="col-4">
                    <br />

                    <center>
                      <img
                        src={`${API_URL}/${data.image}`}
                        alt="Company"
                        className="img-fluid"
                        style={{ maxWidth: '100%' }}
                      />
                    </center>
                  </div>
                </div>
              )}

              {/* Rest of the Invoice Data */}
              {/* {letterRows} */}

              {!data.image && <div>{invoiceRows}</div>}

              {data.note && (
                <div className="row mb-4">
                  <div className="col-12">
                    <p>{data.note}</p>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                {data.signature && (
                  <div className={`col-${data.signature2 ? '6' : '12'}`}>
                    <center>
                      <br />
                      <p>{data.signature}</p>
                      _____________________________
                    </center>
                  </div>
                )}
                {data.signature2 && (
                  <div className={`col-${data.signature ? '6' : '12'}`}>
                    <center>
                      <br />
                      <p>{data.signature2}</p>
                      _____________________________
                    </center>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default InvoicePage;
